<form [formGroup]="loginform" (ngSubmit)="onLoginFormSubmit()">
	<main class="flex flex-column gap-3 mx-4  grid formgrid p-fluid md:mx-auto">
		<div>
		 <p class="color-primary line-height-3" style="font-size:13px">Digite Nombre de Usuario y Contraseña para Iniciar Sesión</p>
		</div>
		<div class="flex flex-column gap-1 app-container-input-blue">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-user"></p-inputIcon>
        <input pInputText id="correo" formControlName="correo" type="text" class="w-full container-input"
               [placeholder]="'components.app-authentication-manager.correo' |
				translate"
               aria-describedby="name-help">
      </p-iconField>
			<ng-container *ngIf="loginform.get('correo')?.touched && loginform.get('correo')?.invalid">
				<app-form-group-error-message [control]="loginform.get('correo')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="flex flex-column gap-1">
      <p-iconField iconPosition="left">
        <i class="p-input-icon pi pi-lock z-1 top-icon"></i>
        <p-password id="password" formControlName="password" [feedback]="false" [toggleMask]="true"
                    [placeholder]="'components.app-authentication-manager.password' | translate"
                    [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" inputStyleClass="container-input">
        </p-password>
      </p-iconField>
			<ng-container *ngIf="loginform.get('password')?.touched && loginform.get('password')?.invalid">
				<app-form-group-error-message [control]="loginform.get('password')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="flex justify-content-between gap-3 mt-4">
			<a class="color-secondary cursor-pointer" (click)="openTab(2)">
				{{"components.app-authentication-manager.olvido-contrasena" | translate}}
			</a>
			<a class="color-secondary  cursor-pointer" (click)="openTab(1)">
				{{"components.app-authentication-manager.quiero-registrarme" | translate}}
			</a>
		</div>
		<div class="flex flex-column align-items-center mt-5">
			<re-captcha formControlName="recaptchaReactive"></re-captcha>
			<ng-container *ngIf="loginform.get('recaptchaReactive')?.touched && loginform.get('recaptchaReactive')?.invalid">
				<app-form-group-error-message [control]="loginform.get('recaptchaReactive')"></app-form-group-error-message>
			</ng-container>
		</div>
		<div class="flex justify-content-center gap-3 mt-5">
			<button pButton type="submit" [label]="'components.app-authentication-manager.btn-iniciar-sesion' | translate"
				class="border-round-xl w-11rem" ></button>
		</div>
	</main>
</form>
<p-toast />

